import React from 'react';
import { cn } from '../lib/utils';

interface GradientTitleProps {
  title: string;
  caption?: string;
  className?: string;
  titleClassName?: string;
  captionClassName?: string;
}

export const GradientTitle: React.FC<GradientTitleProps> = ({
  title,
  caption,
  className,
  titleClassName,
  captionClassName
}) => {
  return (
    <div className={cn('flex flex-col gap-1', className)}>
      <h2 
        className={cn(
          'text-[22px] font-semibold text-tg-text m-0 tracking-[-0.02em] leading-tight',
          'max-[360px]:text-xl',
          titleClassName
        )}
        style={{
          background: 'linear-gradient(135deg, #FF0080, #FF6B00)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}
      >
        {title}
      </h2>
      {caption && (
        <p className={cn('text-sm text-tg-hint m-0 mt-1', captionClassName)}>
          {caption}
        </p>
      )}
    </div>
  );
};

